import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';

function UserAvatar(props) {

  const { classes, givenName, familyName, size, username } = props;
  const avatarText = givenName.substring(0, 1).toUpperCase() + familyName.substring(0, 1).toUpperCase();

  return (
    <Avatar data-test="user-avatar" className={size === "small" ? classes.smallPrimaryAvatar : classes.primaryAvatar}>
      <span data-username={username}>
        {avatarText}
      </span>
    </Avatar>
  );
}

UserAvatar.defaultProps = {
  giveName: "",
  familyName: ""
};

UserAvatar.propTypes = {
  givenName: PropTypes.string,
  familyName: PropTypes.string,
  username: PropTypes.string,
  classes: PropTypes.object,
  size: PropTypes.oneOf(["small", "medium"])
};

export default withStyles(styles)(UserAvatar);